import { type UseQueryResult, useQuery } from 'react-query';
import {
  BrandingPackageService,
  // eslint-disable-next-line camelcase
  type Wealthlane_Dtos_BrandingPackage_BrandingPackageDto,
} from '@wealthlane/api-services/wealthlane-identity-service';

const useGetBrandingPackageDefault = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  enabled: boolean = true
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_Dtos_BrandingPackage_BrandingPackageDto | undefined,
  unknown
> => {
  const brandingPackage = useQuery(
    ['getBrandingPackageDefault'],
    async () => {
      return await handleRequest(
        BrandingPackageService.getApiIdentityApiBrandingPackageDefault()
      );
    },
    {
      enabled,
      keepPreviousData: true,
    }
  );

  return brandingPackage;
};

export default useGetBrandingPackageDefault;
